import { useTranslation } from 'react-i18next';

export default function SolutionsSection() {
  const { t } = useTranslation();
  
  const solutions = [
    {
      title: t('solutions.predictiveMaintenance.title'),
      description: t('solutions.predictiveMaintenance.description'),
      icon: "ri-tools-line",
      image: "https://readdy.ai/api/search-image?query=modern%20industrial%20machinery%20with%20digital%20sensors%20and%20predictive%20maintenance%20technology%20in%20a%20clean%20factory%20environment%20with%20blue%20and%20white%20color%20scheme%20and%20minimalist%20background&width=800&height=600&seq=pred-maint-001&orientation=landscape"
    },
    {
      title: t('solutions.processOptimization.title'), 
      description: t('solutions.processOptimization.description'),
      icon: "ri-settings-3-line",
      image: "https://readdy.ai/api/search-image?query=automated%20industrial%20process%20optimization%20with%20digital%20workflow%20visualization%20and%20efficiency%20metrics%20on%20clean%20white%20background%20with%20modern%20technology%20aesthetic&width=800&height=600&seq=proc-opt-002&orientation=landscape"
    },
    {
      title: t('solutions.qualityControl.title'),
      description: t('solutions.qualityControl.description'),
      icon: "ri-shield-check-line",
      image: "https://readdy.ai/api/search-image?query=advanced%20quality%20control%20inspection%20system%20with%20AI%20vision%20technology%20scanning%20products%20in%20modern%20manufacturing%20facility%20with%20clean%20white%20background&width=800&height=600&seq=qual-ctrl-003&orientation=landscape"
    },
    {
      title: t('solutions.supplyChain.title'),
      description: t('solutions.supplyChain.description'),
      icon: "ri-truck-line",
      image: "https://readdy.ai/api/search-image?query=intelligent%20supply%20chain%20management%20with%20digital%20logistics%20network%20and%20automated%20warehouse%20systems%20on%20clean%20minimalist%20background%20with%20modern%20aesthetic&width=800&height=600&seq=supply-chain-004&orientation=landscape"
    },
    {
      title: t('solutions.energyManagement.title'),
      description: t('solutions.energyManagement.description'),
      icon: "ri-battery-charge-line",
      image: "https://readdy.ai/api/search-image?query=smart%20energy%20management%20system%20with%20renewable%20power%20monitoring%20and%20efficiency%20optimization%20technology%20in%20clean%20industrial%20setting%20with%20white%20background&width=800&height=600&seq=energy-mgmt-005&orientation=landscape"
    },
    {
      title: t('solutions.safetyMonitoring.title'),
      description: t('solutions.safetyMonitoring.description'),
      icon: "ri-eye-line",
      image: "https://readdy.ai/api/search-image?query=industrial%20safety%20monitoring%20system%20with%20AI%20surveillance%20cameras%20and%20worker%20protection%20technology%20in%20modern%20factory%20with%20clean%20white%20background&width=800&height=600&seq=safety-mon-006&orientation=landscape"
    }
  ];

  return (
    <section id="solutions" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-emerald-600 font-semibold text-sm uppercase tracking-wide mb-4">
            {t('solutions.badge')}
          </p>
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            {t('solutions.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('solutions.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="group bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden hover:-translate-y-2"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={solution.image}
                  alt={solution.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-emerald-600/20 group-hover:bg-emerald-600/30 transition-colors duration-300"></div>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-lg mr-4">
                    <i className={`${solution.icon} text-2xl text-emerald-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800">{solution.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">{solution.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
